import type { RouteRecordRaw } from "vue-router";

import authRoutes from "./auth/index";
import coreRoutes from "./core/index";
import { RouteNames } from "./types/names";
import type { AppRouteRecordRaw, MenuItem } from "./types/types";
import { filterRoutesByPermissions, routesToMenuItems } from "./utils/utils";

import catalogRoutes from "@/app/router/catalog/index";
import channelRoutes from "@/app/router/channel/index";
import { useUserStore } from "@/shared/stores/useUserStore";

const modules: Array<AppRouteRecordRaw> = [
  {
    path: "/",
    name: RouteNames.ROOT,
    meta: { title: "Home", showInMenu: false, isRootRedirect: true },
  },
  {
    path: "/403",
    name: RouteNames.FORBIDDEN,
    component: () => import("@/pages/ForbiddenAccess.vue"),
    meta: { title: "Forbidden", showInMenu: false },
  },
  ...coreRoutes,
  ...catalogRoutes,
  ...channelRoutes,
  ...authRoutes,
  {
    path: "/:pathMatch(.*)*",
    name: RouteNames.NOT_FOUND,
    component: () => import("@/pages/NotFound.vue"),
    meta: { title: "Not Found", showInMenu: false },
  },
];

export const menuModules = modules.filter(
  route => route.meta?.showInMenu !== false && route.name,
);

export function getMenuItems(userStore: ReturnType<typeof useUserStore>): MenuItem[] {
  return routesToMenuItems(
    filterRoutesByPermissions(menuModules as RouteRecordRaw[], userStore),
  );
}

export default modules as Array<RouteRecordRaw>;
